// let LOG_TYPE = {
//   default: 0,
//   varDump:1,
//   debug: 2,
//   trace:30,
//   status: 50,
// } // moved to theme file

const appLog = {
  log(str, logType = LOG_TYPE.debug){
    if(environmentVariables.log.enabled){

        if(logType >= environmentVariables.log.logLevel){
            console.log(Date());
            switch(logType){
                case LOG_TYPE.default:
                    console.log(str);
                break;

                default:
                    console.log(str);
            }
        }
    }
  },
  error(err, logType = LOG_TYPE.debug){
      console.error(err)
  },

  LOG_TYPE: LOG_TYPE
}